<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>
const apiPath = require('./apiPath/api.js')
export default {
  name: 'App',
  // beforeMount: function () {
  //             console.log('beforeMount 挂载前状态===============》');
  //             this.$http(apiPath.getCommIdCustomUi, {commId: 34497}, 'get').then(res => {
  //             this.global.setLogo(res.data.logo)
  //             console.log(res);
  //             console.log(222222222222222222);

  // //           })
  //         },
  mounted: function () {
    console.log('mounted 挂载结束状态===============》')
    console.log(this.$route.query)
    // console.log(this.global);
    // if(this.$route.query) {
    //    let  commId = this.$route.query.commId
    //   this.$http(apiPath.getCommIdCustomUi, {commId: commId}, 'get').then(res => {
    //   this.global.setLogo(res.data.logo)
    //   // console.log(res);
    //   // console.log(222222222222222222);
    //   // console.log(this.global);
    //   let icon = res.data.logo
    //   let headHTML = document.getElementsByTagName('head')[0].innerHTML;
    //   headHTML    += `<link rel="shortcut icon"  href=${icon}> -->`;
    //   // headHTML    += '<link type="text/css" rel="stylesheet" href="css/style1920.css">';
    //   document.getElementsByTagName('head')[0].innerHTML = headHTML;
    //   console.log(icon);

    //          })
    // }else {
    //   let  icon = './static/tu_old.ico'
    //   let headHTML = document.getElementsByTagName('head')[0].innerHTML;
    //   headHTML    += `<link rel="shortcut icon"  href=${icon}> -->`;
    //   // headHTML    += '<link type="text/css" rel="stylesheet" href="css/style1920.css">';
    //   document.getElementsByTagName('head')[0].innerHTML = headHTML;
    //   log(213)
    // }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue